import { render, staticRenderFns } from "./EditBankHolidays.vue?vue&type=template&id=2b8ff226&scoped=true"
import script from "./EditBankHolidays.vue?vue&type=script&lang=js"
export * from "./EditBankHolidays.vue?vue&type=script&lang=js"
import style0 from "./EditBankHolidays.vue?vue&type=style&index=0&id=2b8ff226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8ff226",
  null
  
)

export default component.exports